import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bs-statistic__icon"
}
const _hoisted_2 = { class: "bs-statistic__value" }
const _hoisted_3 = { class: "value__label" }
const _hoisted_4 = { class: "value__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-statistic", {
            'bs-statistic--royal-blue': _ctx.color === 'royal-blue',
            'bs-statistic--orange': _ctx.color === 'orange',
            'bs-statistic--green': _ctx.color === 'green',
            'bs-statistic--red': _ctx.color === 'red'
        }])
  }, [
    (_ctx.$slots['icon'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label) + ":", 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.value), 1)
    ])
  ], 2))
}